var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "signin" },
    [
      _c(
        "auth-container",
        { attrs: { writerType: "ilah" } },
        [_c("sign-in-form", { attrs: { propEmail: _vm.email } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }